const ROOT = "audio-viewer";
const AUDIO_TITLE = "audio-title";
const AUDIO_CREATOR = "audio-creator";
const AUDIO_SLIDER = "audio-slider";
const PLUGIN_TOOLBAR_AUDIO_SETTINGS_BUTTON = "plugin-toolbar-audio-settings-button";
const INSERT_AUDIO_BUTTON = "insert-audio-button";
const INSERT_SOUNDCLOUD_BUTTON = "insert-soundcloud-button";
const INSERT_SPOTIFY_BUTTON = "insert-spotify-button";
const INSERT_AUDIO_MODAL = "insert-audio-modal";
const INSERT_AUDIO_MODAL_SOURCE_TOGGLE = "insert-audio-modal-embed-source-toggle";
const EMBED_TAB_URL_INPUT = "insert-audio-modal-embed-input";
const EMBED_TAB_SUBMIT_BUTTON = "insert-audio-modal-action-button-save";
const UPLOAD_TAB_UPLOAD_BUTTON = "insert-audio-modal-custom-upload";
const SETTINGS_MODAL = "audio-settings-modal";
const SETTINGS_AUDIO_NAME_INPUT = "settings-audio-name-input";
const SETTINGS_AUTHOR_NAME_INPUT = "settings-author-name-input";
const SETTINGS_AUDIO_COVER_IMAGE = "settings-cover-image";
const SETTINGS_DOWNLOAD_TOGGLE = "settings-download-toggle";
export {
  AUDIO_CREATOR,
  AUDIO_SLIDER,
  AUDIO_TITLE,
  EMBED_TAB_SUBMIT_BUTTON,
  EMBED_TAB_URL_INPUT,
  INSERT_AUDIO_BUTTON,
  INSERT_AUDIO_MODAL,
  INSERT_AUDIO_MODAL_SOURCE_TOGGLE,
  INSERT_SOUNDCLOUD_BUTTON,
  INSERT_SPOTIFY_BUTTON,
  PLUGIN_TOOLBAR_AUDIO_SETTINGS_BUTTON,
  ROOT,
  SETTINGS_AUDIO_COVER_IMAGE,
  SETTINGS_AUDIO_NAME_INPUT,
  SETTINGS_AUTHOR_NAME_INPUT,
  SETTINGS_DOWNLOAD_TOGGLE,
  SETTINGS_MODAL,
  UPLOAD_TAB_UPLOAD_BUTTON
};
//# sourceMappingURL=data-hooks.js.map
